import { ZodError } from 'zod-validation-error';
import { z } from 'zod';

export type InlineErrorType = {
  path: string;
  message: string;
};

export const parseZodErrors = (error: ZodError) => {
  return error.errors.map((err) => ({
    path: err.path[0] as string,
    message: err.message,
  }));
};
/**
 * function to validate the field should not be empty
 * @return
 */
export const stringFieldSchema = (fieldName: string, message: string) =>
  z.object({
    [fieldName]: z.string().refine(
      (val) => {
        return val.length > 0;
      },
      {
        message,
      },
    ),
  });

export const addressResultSchema = z.object({
  addressSearch: z
    .array(z.any())
    .nonempty('No address found. Please try again.'),
});

const stringConstraints = (message: string) =>
  z.string().refine((val) => val.length > 0, {
    message,
  });

export const yourDetailsSchema = z.object({
  firstName: stringConstraints('Enter a first name'),
  lastName: stringConstraints('Enter a last name'),
  email: z.string().email('Enter a valid email address'),
});
